import React, { useMemo } from "react";
import { SuperTrackMarkupTrack } from "./SuperTrackMarkupTrack";
import { useDrop } from "react-dnd";
import { useDispatch, useSelector } from "react-redux";
import { moveTracks } from "@/store/supertrackSlice";
import { useParams } from "react-router-dom";
import { useActions } from "@/hooks/useActions";

export function SuperTrackMarkupSuperTrack({ superTrack, isDuplicate }) {
  const dispatch = useDispatch();
  const { videoId: matchId } = useParams();
  const {
    frameCount, // used to calculate displayWidth
    superTrackStartTime, // used to calculate displayWidth
    superTrackEndTime, // used to calculate displayWidth
    superTrackGlobalVideoDuration, // used to calculate displayWidth
    isSelectSuperTrack,
  } = useSelector(({ superTracks }) => superTracks);

  const { merge, replace } = useActions();

  const superTrackTracks = useMemo(() => {
    return superTrack.tracks;
  }, [superTrack.tracks]);

  const [{ canDrop, isOver }, drop] = useDrop(
    () => ({
      accept: "Track",
      drop: async ({ track, superTrackId }, monitor) => {
        if (superTrackId === superTrack.id) return;

        if (isSelectSuperTrack) {
          merge(matchId, superTrack.id, superTrackId);
        } else {
          replace(matchId, superTrackId, superTrack.id, [track.track_id]);
          dispatch(
            moveTracks({
              fromId: superTrackId,
              toId: superTrack.id,
              trackIds: [track.track_id],
            })
          );
        }
      },
      collect: (monitor) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
    }),
    [isSelectSuperTrack]
  );

  const isActive = canDrop && isOver;
  let backgroundColor =
    superTrack?.tracks?.length > 0 ? "lightgrey" : "#B5F0C7";
  if (isActive) {
    backgroundColor = "darkgreen";
  } else if (canDrop) {
    backgroundColor = "darkkhaki";
  }

  const displayWidth =
    (frameCount / superTrackGlobalVideoDuration) *
      (superTrackEndTime - superTrackStartTime) *
      0.5 +
    3;

  const trackContainerStyle = {
    width: displayWidth || 0,
    backgroundColor,
    minWidth: "100%",
    overflow: "hidden",
    position: "relative",
  };

  return (
    <div
      className="super-track__tracks-container"
      ref={drop}
      style={trackContainerStyle}
    >
      {superTrackTracks.map(
        (track, index) =>
          track && (
            <SuperTrackMarkupTrack
              style={{ zIndex: index }}
              key={track?.track_id}
              track={track}
              superTrackId={superTrack.id}
              isDuplicate={isDuplicate}
            />
          )
      )}
    </div>
  );
}
